import { GameVars } from "../../../GameVars";
import { BoardContainer } from "../BoardContainer";
import { Tableau } from "./Tableau";
import * as CardCrawl from "@ravalmatic/cardcrawl-engine";

export class UpperTableauContainer extends Tableau {

    private background: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.type = CardCrawl.TableauType.UPPER;
        this.name = CardCrawl.TableauType.UPPER;

        this.background = new Phaser.GameObjects.Image(scene, 0, 78, "texture_atlas_1", "dashboard");
        this.addAt(this.background, 0);
    }

    public onActionProcessed(): void {

        super.onActionProcessed();

        this.sendToBack(this.background);
    }

    public showAllowedMoves(card: CardCrawl.CardData): void {
        
        this.highlightFrames.forEach((frame: Phaser.GameObjects.Image, index: number) => {

            if (GameVars.allowedMoves.upperTableau[index]) {
                
                frame.visible = true;
                frame.scaleX = 1.05;
                frame.scaleY = 1.1;
                this.scene.tweens.add({
                    targets: frame,
                    scaleX: 1,
                    scaleY: 1,
                    duration: 1000,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    repeat: -1,
                    yoyo: false,
                    loopDelay: 300
                });

                if (card) {
                    
                    if (card.type === CardCrawl.CardType.SWORD || card.type === CardCrawl.CardType.SHIELD) {
                        frame.tint = 0xec0038;
                    } else {
                        frame.tint = 0xFFFFFF;
                    }
                }
            }
        });
    }

    public getCardPosition(index: number): {x: number, y: number, angle: number} {

        const x = (index - 1.5) * 187.5;
        const y = BoardContainer.CARD_HEIGHT / 2;
        const angle = 0;
        
        return {x, y, angle};
    }
}
